(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-order-minimum"] && !Shopify.designMode) return;
  try {
    /*
    Order minimum: start the product quantity at the minimum, label it, and keep
    it from going lower whether changed with the -/+ buttons or typed in.
    Runs on page load and whenever quick buy opens.
  */
  (function () {
    if (window.slOrderMinBound) return;
    window.slOrderMinBound = true;

    var apply = function (root) {
      (root || document).querySelectorAll('[data-sl-order-min]').forEach(function (marker) {
        var min = parseInt(marker.getAttribute('data-sl-order-min'), 10) || 1;
        if (min < 2) return;
        var scope = marker.closest('product-form') || marker.closest('.product-form') || document;
        var input = scope.querySelector('.js-product-form input[name="quantity"]') || scope.querySelector('input[name="quantity"]');
        if (!input || input.dataset.orderMin) return;
        input.dataset.orderMin = min;
        input.min = min;
        if ((parseInt(input.value, 10) || 0) < min) input.value = min;
        var label = scope.querySelector('label[for="' + input.id + '"]');
        if (label && !label.querySelector('.sl-qty-min')) {
          var hint = document.createElement('span');
          hint.className = 'sl-qty-min';
          hint.textContent = ' (minimum ' + min + ')';
          label.appendChild(hint);
        }
      });
    };

    document.addEventListener('change', function (evt) {
      var input = evt.target;
      if (!input || !input.matches || !input.matches('input[name="quantity"][data-order-min]')) return;
      var min = parseInt(input.dataset.orderMin, 10) || 1;
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < min) input.value = min;
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { apply(); });
    } else {
      apply();
    }
    document.addEventListener('on:quickbuy:after-open', function () { apply(); });
    document.addEventListener('shopify:section:load', function () { apply(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sl-related-colors"] && !Shopify.designMode) return;
  try {
    /* Related colors: show the hovered colorway's name beside the label. */
  (function () {
    if (window.slRelatedColorsBound) return;
    window.slRelatedColorsBound = true;
    var setName = function (list, name) {
      var wrap = list.closest('.sl-related-colors');
      var label = wrap && wrap.querySelector('.sl-related-colors__name');
      if (label) label.textContent = name || label.dataset.defaultName;
    };
    document.addEventListener('mouseover', function (evt) {
      var swatch = evt.target.closest && evt.target.closest('.sl-related-color');
      if (swatch) setName(swatch.parentElement, swatch.dataset.colorName);
    });
    document.addEventListener('mouseout', function (evt) {
      var list = evt.target.closest && evt.target.closest('.sl-related-colors__list');
      if (!list || (evt.relatedTarget && list.contains(evt.relatedTarget))) return;
      setName(list, null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
